import api from "../../../services/api";

export async function deleteEventService(keypointId: string): Promise<void> {
  await api.delete(`/api/key_points/${keypointId}`);
}